import { render } from "./PhotoWall.vue?vue&type=template&id=469ab497"
import script from "./PhotoWall.vue?vue&type=script&lang=ts"
export * from "./PhotoWall.vue?vue&type=script&lang=ts"
script.render = render

export default script